{
  "enum": {
    "IxcCorpactionsCaadminV1ActionStatus": {
      "APPROVED": "Approved",
      "CANCELED": "Canceled",
      "COMPLETE": "Complete",
      "DRAFT": "Draft",
      "PARTIAL": "Partial",
      "REVERSED": "Reversed",
      "UNSPECIFIED": "Unspecified",
      "UPDATE_DRAFT": "Update Draft"
    },
    "IxcCorpactionsCaadminV1CancelOverride": {
      "CANCELED": "Canceled",
      "NOT_CANCELED": "Not Canceled",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcCorpactionsCaadminV1MergeType": {
      "APPEND": "Append",
      "REPLACE": "Replace",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcCorpactionsCaadminV1PaymentStatus": {
      "CANCELED": "Canceled",
      "CONFIRMED": "Confirmed",
      "EXPECTED": "Expected",
      "REVERSED": "Reversed",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcCorpactionsCaadminV1ActionQueryServiceActionListFilterableFields": {
      "actionId": "Action",
      "assetId": "Asset",
      "data": {
        "approvedVersion": {
          "data": {
            "header": {
              "actionType": "Approved Version: Action Type",
              "cumDate": "Approved Version: Cum Date",
              "cusip": "Approved Version: CUSIP",
              "effectiveDate": "Approved Version: Effective Date",
              "exDate": "Approved Version: Ex-Date",
              "paymentDate": "Approved Version: Payment Date",
              "recordDate": "Approved Version: Record Date",
              "timeApplicable": "Approved Version: Time Applicable"
            }
          }
        },
        "candidateVersion": {
          "data": {
            "header": {
              "actionType": "Candidate Version: Action Type",
              "cumDate": "Candidate Version: Cum Date",
              "cusip": "Candidate Version: CUSIP",
              "effectiveDate": "Candidate Version: Effective Date",
              "exDate": "Candidate Version: Ex-Date",
              "paymentDate": "Candidate Version: Payment Date",
              "recordDate": "Candidate Version: Record Date",
              "timeApplicable": "Candidate Version: Time Applicable"
            }
          }
        },
        "referencedSecurities": {
          "assetId": "Referenced Securities: Asset",
          "data": {
            "category": "Referenced Securities: Category",
            "type": {
              "!type": "Referenced Securities: Type",
              "equity": {
                "controls": {
                  "canBuy": "Referenced Securities: Equity Controls Can Buy",
                  "canEnterFractions": "Referenced Securities: Equity Controls Can Enter Fractions",
                  "canSell": "Referenced Securities: Equity Controls Can Sell"
                },
                "cusip": "Referenced Securities: Equity CUSIP"
              },
              "moneyMarket": {
                "classification": "Referenced Securities: Money Market Classification",
                "controls": {
                  "canBuy": "Referenced Securities: Money Market Controls Can Buy",
                  "canEnterFractions": "Referenced Securities: Money Market Controls Can Enter Fractions",
                  "canSell": "Referenced Securities: Money Market Controls Can Sell"
                },
                "cusip": "Referenced Securities: Money Market CUSIP",
                "navType": "Referenced Securities: Money Market NAV Type"
              }
            }
          },
          "status": "Referenced Securities Status"
        },
        "referencedVersions": {
          "data": {
            "header": {
              "actionType": "Referenced Versions: Action Type",
              "cumDate": "Referenced Versions: Cum Date",
              "cusip": "Referenced Versions: CUSIP",
              "effectiveDate": "Data Referenced Versions Data Header Effective Date",
              "exDate": "Referenced Versions: Ex-Date",
              "paymentDate": "Referenced Versions: Payment Date",
              "recordDate": "Referenced Versions: Record Date",
              "timeApplicable": "Referenced Versions: Time Applicable"
            }
          }
        },
        "underlyingSecurity": {
          "assetId": "Underlying Security Asset",
          "data": {
            "category": "Underlying Security: Category",
            "type": {
              "!type": "Underlying Security: Type",
              "equity": {
                "controls": {
                  "canBuy": "Underlying Security: Equity Controls Can Buy",
                  "canEnterFractions": "Underlying Security: Equity Controls Can Enter Fractions",
                  "canSell": "Underlying Security: Equity Controls Can Sell"
                },
                "cusip": "Underlying Security: Equity CUSIP"
              },
              "moneyMarket": {
                "classification": "Underlying Security: Money Market Classification",
                "controls": {
                  "canBuy": "Underlying Security: Money Market Controls Can Buy",
                  "canEnterFractions": "Underlying Security: Money Market Controls Can Enter Fractions",
                  "canSell": "Underlying Security: Money Market Controls Can Sell"
                },
                "cusip": "Underlying Security: Money Market CUSIP",
                "navType": "Underlying Security: Money Market NAV Type"
              }
            }
          },
          "status": "Underlying Security Status"
        }
      },
      "status": "Status"
    },
    "IxcCorpactionsCaadminV1PaymentQueryServicePaymentListFilterableFields": {
      "actionId": "Action",
      "assetId": "Asset",
      "data": {
        "dtc": {
          "dtcHeader": {
            "eventId": "DTC Header Event ID",
            "paymentId": "DTC Header Payment",
            "underlyingCusip": "DTC Header Underlying CUSIP"
          }
        },
        "expectedPaymentDate": "Expected Payment Date"
      },
      "paymentId": "Payment",
      "status": "Status"
    }
  },
  "oneOf": {
    "IxcCorpactionsCaadminV1ActionEventType": {
      "approved": "Approved",
      "canceled": "Canceled",
      "dataUpdated": "Data Updated",
      "deferredWait": "Deferred Wait",
      "done": "Done",
      "dtcCancellation": "DTC Cancellation",
      "dtcNotification": "DTC Notification",
      "manualCreate": "Manual Create",
      "manualUpdate": "Manual Update",
      "retracted": "Retracted",
      "securityUpdate": "Security Update",
      "trigger": "Trigger",
      "updateCalendar": "Update Calendar"
    },
    "IxcCorpactionsCaadminV1CashInLieuOverrideRate": {
      "unknown": "Unknown",
      "value": "Value"
    },
    "IxcCorpactionsCaadminV1CashInLieuOverrideTimeApplicable": {
      "unknown": "Unknown",
      "value": "Value"
    },
    "IxcCorpactionsCaadminV1PaymentEventType": {
      "eventProcessingStatus": "Event Processing Status",
      "movementConfirmation": "Movement Confirmation",
      "movementReversal": "Movement Reversal",
      "paymentAdvice": "Payment Advice",
      "paymentCancelAdvice": "Payment Cancel Advice"
    }
  },
  "searchEnum": {
    "IxcCorpactionsCaadminV1ActionQueryServiceActionListSearchableFields": {
      "data": {
        "referencedSecurities": {
          "data": {
            "type": {
              "equity": {
                "name": "Referenced Securities: Equity Name",
                "symbol": {
                  "base": "Referenced Securities: Equity Symbol Base"
                }
              },
              "moneyMarket": {
                "name": "Referenced Securities: Money Market Name",
                "symbol": {
                  "base": "Referenced Securities: Money Market Symbol Base"
                }
              }
            }
          }
        },
        "underlyingSecurity": {
          "data": {
            "type": {
              "equity": {
                "name": "Underlying Security: Equity Name",
                "symbol": {
                  "base": "Underlying Security: Equity Symbol Base"
                }
              },
              "moneyMarket": {
                "name": "Underlying Security: Money Market Name",
                "symbol": {
                  "base": "Underlying Security: Money Market Symbol Base"
                }
              }
            }
          }
        }
      }
    }
  },
  "sortEnum": {
    "IxcCorpactionsCaadminV1ActionQueryServiceActionListSortableFields": {
      "data": {
        "approvedVersion": {
          "data": {
            "header": {
              "cumDate": "Approved Version: Cum Date",
              "effectiveDate": "Approved Version: Effective Date",
              "exDate": "Approved Version: Ex-Date",
              "paymentDate": "Approved Version: Payment Date",
              "recordDate": "Approved Version: Record Date",
              "timeApplicable": "Approved Version: Time Applicable"
            }
          }
        },
        "candidateVersion": {
          "data": {
            "header": {
              "cumDate": "Candidate Version: Cum Date",
              "effectiveDate": "Candidate Version: Effective Date",
              "exDate": "Candidate Version: Ex-Date",
              "paymentDate": "Candidate Version: Payment Date",
              "recordDate": "Candidate Version: Record Date",
              "timeApplicable": "Candidate Version: Time Applicable"
            }
          }
        },
        "underlyingSecurity": {
          "metadata": {
            "createdAt": "Created At",
            "updatedAt": "Updated At"
          }
        }
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcCorpactionsCaadminV1PaymentQueryServicePaymentListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}